define('mailsMailRightCollapsedAttachmentView',[
  'module',
  'windows',
  'marionette',
  'underscore',
  'template!mailsMailRightCollapsedAttachmentView',
  'emailAttachmentDefaultView',
  'emailAttachmentImageView',
  'emailAttachmentPdfView'
], function (
  Module,
  Windows,
  Marionette,
  _,
  Tpl,
  DefaultView,
  ImageView,
  PdfView
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,    
    className: 'attachment-view',
    
    ui: {
      name: '.name',
      remove: '.delete',
      reload: '.reload',
      pdfCanvas: '.pdf-canvas',
      image: '.image',
      loading: '.loading'
    },

    regions: {
      viewRegion: '.view-region'
    },

    serializeData: function () {
      return {
        name: this.model.get('fileName'),
        url: this.options.mailModel.getDowloadUrl(this.options.mailSecId, this.model.get('fileName')),
        fileName: this.model.get('fileName'),
        inline: !!this.model.get('inline')
      };
    },

    onShow: function() {

      var options = {
        model: this.model,
        url: this.options.mailModel.getDowloadUrl(this.options.mailSecId, this.model.get('fileName')),
        fileName: this.model.get('fileName'),
        size: this.model.get('size')
      };

      if(this.model.get('contentType') === 'application/pdf' || this.model.get('contentType') === 'application/octet-stream')
        this.view = new PdfView(options);

      var imageTypes = [
          'image/jpeg',
          'image/jpg',
          'image/png',
          'image/x-png',
          'image/gif'
      ];

      if (imageTypes.includes(this.model.get('contentType')))
        this.view = new ImageView(options);

      if(!this.view)
        this.view = new DefaultView(options);

      this.getRegion('viewRegion').show(this.view);

      this._url = options.url;
      this.view.on('click', _.bind(this.onAttachmentClick, this));

      this.fetch().done(_.bind(function () {
        this.trigger('loaded');
      }, this));
    },

    // Image / PDF attachments are previewable. When the host enabled preview
    // (e.g. the Sales Inbox / Threads conversation), clicking opens an in-app
    // modal; otherwise keep the original behaviour (open in a new tab).
    isPreviewable: function () {
      var ct = (this.model.get('contentType') || '').toLowerCase();
      return ct.indexOf('image/') === 0 || ct === 'application/pdf';
    },

    onAttachmentClick: function () {
      if (this.options.preview && this.isPreviewable()) {
        this.openPreview();
      } else if (this._url) {
        window.open(this._url, '_blank');
      }
    },

    // Open the attachment in a modal: an <img> for images, and a blob-backed
    // <iframe> for PDFs (a Blob URL renders inline regardless of the file's
    // Content-Disposition, which the raw download URL would force to download).
    openPreview: function () {
      var url = this._url;
      var name = this.model.get('fileName') || 'Attachment';
      var isImage = (this.model.get('contentType') || '').toLowerCase().indexOf('image/') === 0;

      var PreviewView = Marionette.ItemView.extend({
        className: 'attachment-preview',
        attributes: { style: 'display:block;width:100%;height:100%;' },
        template: _.template(
          '<div style="position:relative;width:100%;height:100%;display:flex;flex-direction:column;background:#f3f5f8;">' +
          '  <div class="ap-stage" style="flex:1;min-height:0;display:flex;align-items:center;justify-content:center;overflow:auto;padding:12px;">' +
          '    <% if (isImage) { %>' +
          '      <img src="<%= url %>" alt="<%= name %>" style="max-width:100%;max-height:100%;object-fit:contain;background:#fff;box-shadow:0 2px 14px rgba(0,0,0,.14);"/>' +
          '    <% } else { %>' +
          '      <div class="ap-loading" style="color:#667085;font-size:13px;">Loading preview…</div>' +
          '      <iframe class="ap-frame" title="<%= name %>" style="width:100%;height:100%;border:0;background:#fff;display:none;"></iframe>' +
          '    <% } %>' +
          '  </div>' +
          '  <div style="flex:0 0 auto;display:flex;justify-content:flex-end;gap:12px;padding:8px 14px;border-top:1px solid #e0e3e8;background:#fff;">' +
          '    <a href="<%= url %>" target="_blank" download="<%= name %>" style="font-size:12px;font-weight:600;color:#1976d2;text-decoration:none;">Download</a>' +
          '  </div>' +
          '</div>'
        ),
        templateHelpers: function () { return { url: url, name: name, isImage: isImage }; },
        onShow: function () {
          if (isImage) { return; }
          var self = this;
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.onload = function () {
            if (self.isDestroyed) { return; }
            if (xhr.status === 200) {
              self._blobUrl = window.URL.createObjectURL(xhr.response);
              self.$('.ap-frame').attr('src', self._blobUrl).css('display', 'block');
              self.$('.ap-loading').hide();
            } else {
              self.$('.ap-loading').text('Could not load preview.');
            }
          };
          xhr.onerror = function () {
            if (!self.isDestroyed) { self.$('.ap-loading').text('Could not load preview.'); }
          };
          xhr.send();
        },
        onDestroy: function () {
          if (this._blobUrl) { window.URL.revokeObjectURL(this._blobUrl); }
        }
      });

      Windows.open({
        view: function () { return new PreviewView(); },
        id: 'attachment-preview',
        title: name,
        modal: true,
        width: '80%',
        height: '88%'
      });
    },

    fetch: function() {
      var defer = $.Deferred();
      if(this.model.get('loaded') === true)
        return defer.resolve();
      else {
        if(this.model.get('url')) {
          var req = new XMLHttpRequest();
          req.addEventListener('load', _.bind(function (result) {
            if (result.currentTarget.status === 200) {
              this.model.set('arrayBuffer', result.currentTarget.response);
              this.model.set('base64', this.arrayBufferToBase64(this.model.get('arrayBuffer')));
              this.model.set('content-disposition', 'attachment; filename=' + this.model.get('name'));
              this.model.set('loaded', true);
            }
            defer.resolve();
          }, this));
          req.open('GET', this.model.get('url'));
          req.responseType = 'arraybuffer';
          req.send();
        }
      }
      return defer.promise();
    },

    arrayBufferToBase64: function (buffer) {
      var binary = '';
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    }
  });
});
  
